// extracted by mini-css-extract-plugin
export default {"Dots":"styles_Dots__5+m98","dot":"styles_dot__w0SIz","active":"styles_active__7cDnM"};